import React, { Component } from 'react';

import { connect } from 'react-redux';

import {
    Form, Row, Col, Radio, Input, DatePicker, Select, Button,
} from 'antd';

import moment from 'moment';

const FormItem = Form.Item;
const RadioGroup = Radio.Group;
const { Option } = Select;

class UnwrappedMedicineTenure extends Component {
    state = {
        value: '',
    }

    onChange = (e) => {
        this.setState({
            value: e.target.value,
        });
    }

    handleSubmit = (e) => {
        e.preventDefault();

        const { form, handleMedicineTenure, onCancel } = this.props;

        form.validateFields((err, values) => {
            if (err) {
                return;
            }

            this.handleFinal(values);

            handleMedicineTenure(values);
            onCancel();
        });
    }

    handleFinal = (values) => {
        const { end_date } = this.props;

        if (values.type === 1) {
            values.end_date = end_date;
        } else {
            let duration;
            if (values.duration === 'day') {
                duration = 'd';
            } else if (values.duration === 'week') {
                duration = 'w';
            } else if (values.duration === 'month') {
                duration = 'M';
            }
            if (values.duration === 'day') {
                values.end_date = moment(values.start_date).add(Number(values.period) - 1, duration);
            } else if (values.duration === 'week') {
                values.end_date = moment(values.start_date).add(Number(values.period), duration).subtract(Number(values.period), 'days');
            } else {
                values.end_date = moment(values.start_date).add(Number(values.period), duration);
            }
        }

        values.start_date = moment(values.start_date).format('YYYY-M-D');
        values.end_date = moment(values.end_date).format('YYYY-M-D');

        delete values.period;
        delete values.duration;
        delete values.type;
    }

    render() {
        const {
            form, data, selectedMed, changeActiveKey, start_date,
        } = this.props;
        const { value } = this.state;
        const { getFieldDecorator, getFieldValue } = form;

        const { end_date } = data;

        const medName = selectedMed.split('#')[1];

        const suffixSelector = getFieldDecorator('duration', {
            initialValue: 'day',
        })(
            <Select style={{ width: 100 }}>
                <Option value="duration">Duration</Option>
                <Option value="day">Day</Option>
                <Option value="week">Week</Option>
                <Option value="month">Month</Option>
            </Select>,
        );


        return (
            <div style={{ margin: 'auto', paddingTop: '5%', textAlign: 'center' }}>

                <h5 style={{ textAlign: 'center' }}>{medName}</h5>

                <Form onSubmit={this.handleSubmit}>
                    <div style={{ height: '390px', overflow: 'auto', textAlign: 'center' }}>

                        <Row type="flex" justify="center">

                            <Col span={14}>
                                <FormItem
                                    label="Start Date"
                                >
                                    {getFieldDecorator('start_date', {
                                        rules: [{ required: true, message: 'Please select a start date!' },
                                        {
                                            validator: (_, value) => {
                                                if (value && value.isBefore(moment(), 'day')) {
                                                    return Promise.reject('Start date cannot be in the past!');
                                                }
                                                return Promise.resolve();
                                            }
                                        }
                                        ],
                                        initialValue: start_date == null
                                            ? moment(start_date)
                                            : moment(start_date),
                                    })(
                                        <DatePicker
                                            style={{ width: '50%' }}
                                            disabledDate={current => current && current < moment().endOf('day')}
                                        />,
                                    )}
                                </FormItem>
                            </Col>

                        </Row>

                        <FormItem>

                            {getFieldDecorator('type', {
                                rules: [{ required: true, message: 'Please select a start date!' }],
                                initialValue: end_date == null ? 1 : 2,
                            })(
                                <RadioGroup onChange={this.onChange} value={value}>
                                    <Radio value={1}>Tenure End Date</Radio>
                                    <Radio value={2}>
                                        Custom
                                        {getFieldDecorator('period', {
                                            rules: [{ required: false, message: 'Please select a expiry date!' }],
                                            initialValue: end_date == null ? '' : moment(end_date).diff(moment(start_date), 'days') + 1,
                                        })(
                                            <Input
                                                disabled={getFieldValue('type') !== 2}
                                                addonAfter={suffixSelector}
                                                style={{ width: 200, marginLeft: 50 }}
                                            />,
                                        )}
                                    </Radio>
                                </RadioGroup>,
                            )}

                        </FormItem>

                        <Row type="flex" justify="center" style={{ marginTop: '10%' }}>
                            <Col span={12}>
                                <FormItem>
                                    <Button type="primary" onClick={() => changeActiveKey('3')}>To Prev</Button>
                                </FormItem>
                            </Col>
                            <Col span={12}>
                                <FormItem>
                                    <Button type="primary" htmlType="submit">Finish</Button>
                                </FormItem>
                            </Col>
                        </Row>

                    </div>
                </Form>
            </div>
        );
    }
}

const MedicineTenure = Form.create()(UnwrappedMedicineTenure);

const mapStateToProps = state => ({
    start_date: state.AppState.start_date,
    end_date: state.AppState.end_date,
});

export default connect(mapStateToProps, null)(MedicineTenure);



// WEBPACK FOOTER //
// ./src/component/AddingMedToOrder/TabsComponents/MedicineTenure.js